import { smoother, bootstrap, disableSubmitForm, displayDynamicPlan, choicesjsForPlan, inputFormTooltip } from '../default';
import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import Choices from 'choices.js'

function heroSwiper() {
    const swiper = new Swiper('.hero__swiper', {
        modules: [Autoplay, Navigation, Pagination],
        speed: 600,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        autoplay: {
            delay: 5000,
        },
        loop: true,
    })
}

function choiceJs() {
    const customSelect = document.querySelectorAll('.custom-form__select');

    customSelect.forEach(cs => {
        const choices = new Choices(cs, {
            searchEnabled: false,
            itemSelectText: ' ',
            allowHTML: true,
            shouldSort: false,
        })
    });
}

function videoModal() {

    const myModal = document.getElementById('videoModal')
    const videoIframe = document.querySelector('.video__modal-iframe iframe')
    const videoSrc = videoIframe.src

    myModal.addEventListener('show.bs.modal', () => {
        smoother().kill()
    })

    myModal.addEventListener('hidden.bs.modal', () => {
        smoother()
        videoIframe.setAttribute('src', videoSrc)
    })
}

function popup() {
    const modalPopup = document.querySelector('#modalPopup')
    
    if (modalPopup) {
        const modalPopupInit = new bootstrap.Modal(modalPopup)
        
        modalPopup.addEventListener('show.bs.modal', () => {
            smoother().kill()
        })
        
        modalPopup.addEventListener('hidden.bs.modal', () => {
            smoother()
        })
        
        setTimeout(() => {
            modalPopupInit.show()
        }, 8000);
    }

}

window.addEventListener('DOMContentLoaded', () => {
    smoother()
    heroSwiper()
    displayDynamicPlan()
    choicesjsForPlan()
    disableSubmitForm()
    videoModal()
    inputFormTooltip()
    popup()
})